
import type { PropType } from 'vue'
import type { TimeSlotByDayChildren } from '@/new-services/types/time-slots'

import { defineComponent } from 'vue'

import TimeSlotByDayResources from './TimeSlotByDayResources.vue'
import TimeSlotByDaySectors from './TimeSlotByDaySectors.vue'

export default defineComponent({
    components: {
        TimeSlotByDayResources,
        TimeSlotByDaySectors
    },
    props: {
        item: {
            type: Object as PropType<TimeSlotByDayChildren>,
            required: true
        }
    },
    emits: ['change-status'],
    setup(props, { emit }) {
        const onChangeStatus = () => emit('change-status', { timeSlotId: props.item.id, statusId: props.item.status.id })
        const format = (timeStr: string) => timeStr.substring(0, 5)

        const getPeriod = (periodStart: string, periodEnd: string) => {
            let periodEndHours = Number(periodEnd.split(':')[0])

            if (periodEndHours === 23) {
                return `${periodStart} — 00:00`
            }

            periodEndHours = periodEndHours + 1

            return `${periodStart} — ${periodEndHours.toString().padStart(2, '0')}:00`
        }

        return {
            format,
            getPeriod,
            onChangeStatus
        }
    }
})
